module.exports = __webpack_public_path__ + "static/media/4.c64d90c2.jpg";